import { i18nBuilder } from 'keycloakify/login';

import type { ThemeName } from '../kc.gen';

/** @see: https://docs.keycloakify.dev/i18n */
const { useI18n, ofTypeI18n } = i18nBuilder
	.withThemeName<ThemeName>()
	.withCustomTranslations({
		en: {
			loginHeader: 'Вход и регистрация',
			loginHeaderOtp: 'Вход по номеру телефона',
			loginDescriptionTitle: 'Сэкономьте время',
			loginDescription:
				'Войдите через «Госуслуги» или банковские ID — анкета заполнится автоматически. Это безопасно',
			loginDescriptionIOS:
				'Войдите через «Госуслуги» — анкета заполнится автоматически. Это безопасно',
			loginDescriptionOtp: 'Вход через вашего оператора связи. Данные защищены шифрованием.',
			doLogIn: 'Войти',
			anotherWays: 'или',
			moreWays_one: 'Еще {0} способ',
			moreWays_two: 'Еще {0} способа',
			moreWays_five: 'Еще {0} способов',
			esiaLabel: 'Госуслуги',
			phoneNumber: 'Телефон',
			smsSent: 'Код отправлен на номер',
			totp: 'Код',
			resendButton: 'Запросить код через {0}',
			resendButtonActive: 'Получить код еще раз',
			loginTitle: 'Вход на сайт | Банки.ру',
			invalidPhoneNumber: 'Введен недопустимый номер телефона',
			mobileIdTitle: 'Подождите немного',
			mobileIdDescription:
				'Сейчас на ваш телефон поступит пуш-сообщение для входа Если пуш не пришел, дождитесь смс',
			timeLeft: 'Осталось',
			logoutConfirmTitle: 'Выход',
			logoutConfirmHeader: 'Вы действительно хотите выйти?',
			doLogout: 'Выйти',
			backToApplication: 'Вернуться',
			pageExpiredTitle: 'Сессия истекла',
			pageExpiredMsg1: 'Для продолжения',
			pageExpiredRefresh: 'обновите страницу',
		},
		ru: {
			loginHeader: 'Вход и регистрация',
			loginHeaderOtp: 'Вход по номеру телефона',
			loginDescriptionTitle: 'Сэкономьте время',
			loginDescription:
				'Войдите через «Госуслуги» или банковские ID — анкета заполнится автоматически. Это безопасно',
			loginDescriptionIOS:
				'Войдите через «Госуслуги» — анкета заполнится автоматически. Это безопасно',
			loginDescriptionOtp: 'Вход через вашего оператора связи. Данные защищены шифрованием.',
			doLogIn: 'Войти',
			anotherWays: 'или',
			moreWays_one: 'Еще {0} способ',
			moreWays_two: 'Еще {0} способа',
			moreWays_five: 'Еще {0} способов',
			esiaLabel: 'Госуслуги',
			phoneNumber: 'Телефон',
			smsSent: 'Код отправлен на номер',
			totp: 'Код',
			resendButton: 'Запросить код через {0}',
			resendButtonActive: 'Получить код еще раз',
			loginTitle: 'Вход на сайт | Банки.ру',
			invalidPhoneNumber: 'Введен недопустимый номер телефона',
			mobileIdTitle: 'Подождите немного',
			mobileIdDescription:
				'Сейчас на ваш телефон поступит пуш-сообщение для входа Если пуш не пришел, дождитесь смс',
			timeLeft: 'Осталось',
			logoutConfirmTitle: 'Выход',
			logoutConfirmHeader: 'Вы действительно хотите выйти?',
			doLogout: 'Выйти',
			backToApplication: 'Вернуться',
			pageExpiredTitle: 'Сессия истекла',
			pageExpiredMsg1: 'Для продолжения',
			pageExpiredRefresh: 'обновите страницу',
		},
	})
	.build();

type I18n = typeof ofTypeI18n;

export { useI18n, type I18n };
